// App version shown in the top bar (mobile + desktop). scripts/write-version.js
// (prestart / prebuild) copies versionName + versionCode from
// android/app/build.gradle into REACT_APP_VERSION for every start and build; the
// release scripts set it too. The constant is only a last-resort fallback.
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.2';
